<template>
  <layout-default-app-bar :back-to=true>
    {{ titulo }}
  </layout-default-app-bar>
</template>

<script>
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      titulo: 'Pesquisa',
      rotaVoltar: true,
    };
  },

  created() {
    this.definirTitulo();
    // this.verificarRotaDeRetorno();
  },

  methods: {
    definirTitulo() {
      const abaAtiva = this.$route.query.aba;
      switch (abaAtiva) {
        case 'financeiro':
          this.titulo = 'Financeiro';
          break;
        case 'vendas':
          this.titulo = 'Histórico de Vendas';
          break;
        default:
          this.titulo = 'Consulta Cliente';
      }
    },

    // verificarRotaDeRetorno() {
    //   const idPedido = sessionStorage.getItem('retornoIdPedido');

    //   if (idPedido) {
    //     let idcliente = sessionStorage.getItem('retornoIdCliente');

    //     this.rotaVoltar = {
    //       path: '/cadastro-pedido', 
    //       query: {
    //         id: idPedido,
    //         idcliente: idcliente
    //       }
    //     };
        
    //     // console.log("AppBar: Redirecionamento configurado para Pedido ID:", idPedido);
    //     // console.log("AppBar: Redirecionamento configurado para Cliente ID:", idcliente);
    //   } else {
    //     this.rotaVoltar = true;
    //   }
    // }
  },
};
</script>

<style scoped>
  #icone{
    top: 6%;
    position: relative;
  }

  #texto {
    position: absolute;
    left: 120px;
    bottom: 8px;
    font-size: 24px;
  }
</style>